module.exports = __webpack_public_path__ + "../resources/img/go.656aabc0.svg";